import React, { FunctionComponent } from "react";
import styles from "./Footer3.module.scss";
import Footer3Props from "./Footer3Props.interface";
import setFooterStyles from "./hooks/setFooterStyles";
import Anchor from "components/Anchor/Anchor";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Paragraph from "components/Paragraph/Paragraph";
import IconViewer from "components/IconViewer/IconViewer";

const Footer3: FunctionComponent<Footer3Props> = (props) => {
    let footer: any;
    if (props?.theme?.footer && props?.theme?.footer.length > 0) {
        footer = props?.theme?.footer?.[0]?.content;
    }

    const footerStyles = setFooterStyles(footer);

    const imageAspectRatio = getImageAspectRatio(undefined, footer?.footerLogo?.umbracoWidth, footer?.footerLogo?.umbracoHeight);
    const certificationIcon = props?.certificationIcon?.toLowerCase().replace(/ /g, "-");

    return (
        <footer className={styles.wrapper} style={footerStyles}>
            {/* Top */}
            <div className={styles.top_wrapper}>
                <div className={styles.top}>
                    {footer?.footerLogo ? (
                        <ImageViewer className={styles.image} src={footer.footerLogo.umbracoFile.src} extensionType="png" type="contain" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    ) : null}

                    {props.address ? (
                        <div className={styles.address_wrapper}>
                            {/* Heading */}
                            {props.addressHeading ? (
                                <h3 className={styles.heading}>{props.addressHeading}</h3>
                            ) : null}

                            {/* Description */}
                            {props.address ? (
                                <Paragraph className={styles.text} innerHTML={props.address} />
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>

            {/* Bottom */}
            <div className={styles.bottom_wrapper}>
                <div className={styles.bottom}>
                    <div className={styles.copyright}>&copy; {new Date().getFullYear()} Copyright {props.theme?.siteName}</div>

                    <div className={styles.links_wrapper}>
                        {props.certificationIcon && props.certificationLink ? (
                            <Anchor className={styles.certification} to={props.certificationLink?.[0].content.link}>
                                <IconViewer name={certificationIcon} />
                                <p>{props.certificationLink?.[0].content.label}</p>
                            </Anchor>
                        ) : null}

                        {props.footerLinks && props.footerLinks.length > 0 ? (
                            <nav>
                                {props.footerLinks?.map((footerLink: any, index: number) => {
                                    return (
                                        <Anchor key={index} className={styles.link} to={footerLink.content.link}>
                                            {footerLink.content.label}
                                        </Anchor>
                                    );
                                })}
                            </nav>
                        ) : null}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer3;